// Configuration file for API endpoints

const config = {
  // For local testing, use localhost backend
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  API_JS_URL: process.env.REACT_APP_API_JS_URL,
  /** Exskilence-marimo-validator base or full /v1/run URL (notebook Run/Validate). */
  MARIMO_VALIDATOR_URL: process.env.REACT_APP_MARIMO_VALIDATOR_URL,
};

export default config; 